module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone.6df0d0f5.svg";